import escapeData from "./escapeData";

const apiUrl = process.env.REACT_APP_API_URL || '';

export const getRequest = <T> ( 
  dataProps: T,
  serviceProps: string,
  methodProps: string,
  methodFetch: string,
) => {
  return fetch(apiUrl, { 
    method: methodFetch,
    credentials: 'include',
    body: JSON.stringify({
      method: methodProps,
      service: serviceProps,
      data: escapeData(dataProps),
    }),
   
  });
};
